import { useState } from 'react';
import { useQueryClient } from 'react-query';
import request from 'app/api/request';
import { dispatchReportError, dispatchReportErrorKey } from './reportErrorToast';
import {
  validationQueryKeys,
  XbrlValidationRunPlain,
  LatestValidation,
  ValidationResult,
  ValidationStatus,
  CategoryResult,
  Severity,
  ValidationFinding,
  ValidationCategory,
} from 'app/api/validation-queries';

export type { ValidationResult, ValidationStatus, CategoryResult, Severity, ValidationFinding, ValidationCategory };

export interface UseRunValidationInput {
  documentSuperId: string;
  documentRevisionId: string | undefined;
}

export function useRunValidation({ documentSuperId, documentRevisionId }: UseRunValidationInput) {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState<ValidationResult | null>(null);
  const queryClient = useQueryClient();

  const run = async () => {
    if (isRunning) return;
    if (!documentRevisionId) {
      dispatchReportErrorKey('validation');
      return;
    }
    setIsRunning(true);
    try {
      const url = `/gaby/validation/${documentSuperId}?documentRevisionId=${documentRevisionId}`;
      const res = await request.post(url, {});
      const persisted = res.data as XbrlValidationRunPlain;
      setResult(persisted.result);
      queryClient.setQueryData<LatestValidation>(validationQueryKeys.latest(documentSuperId), { latest: persisted, stale: false });
    } catch (err) {
      dispatchReportError('validation', err);
    } finally {
      setIsRunning(false);
    }
  };

  return { run, isRunning, result };
}
